import { ApiBase, WebApi } from "~/extensions/api";
import { NonRedirect404WebApi } from "~/extensions/api/NonRedirect404WebApi";
import { GetBukenCommand, GetDepartmentListCommand, GetHanyoListCommand, GetKeiyakushaCommand, GetMessageCommand } from "./Commands";
import { FindAddressCommand } from "./Commands/FindAddressCommand";
export class CommonApi extends ApiBase {
    /**メッセージ取得 */
    getMessages() {
        let command = new GetMessageCommand();
        return this.request(command);
    }
    /**汎用リスト取得 */
    getHanyoList(hanyoIdList) {
        let command = new GetHanyoListCommand(hanyoIdList);
        return this.request(command);
    }
    /**部署リスト取得 */
    getDepartmentList() {
        let command = new GetDepartmentListCommand();
        return this.request(command);
    }
    /**物件取得 */
    async getBuken(buknCd) {
        let command = new GetBukenCommand(buknCd);
        const request = WebApi.requestFactory.create(command);
        const result = await NonRedirect404WebApi.request(request);
        if (!result) {
            return null;
        }
        return result.data;
    }
    /**契約者取得 */
    async getKeiyakusha(nyukyokeiyakuNo) {
        let command = new GetKeiyakushaCommand(nyukyokeiyakuNo);
        const request = WebApi.requestFactory.create(command);
        const result = await NonRedirect404WebApi.request(request);
        if (!result) {
            return null;
        }
        return result.data;
    }
    /**公開鍵取得 */
    getKey() {
        return this.api.get("common/publicKey");
    }
    getDomain() {
        return this.api.get("common/adminDomain");
    }
    getSetting() {
        return this.api.get("common/settings");
    }
    /**MT-Functionsのパスワード再発行画面URL取得 */
    getPasswordResetUrl() {
        return this.api.get("common/passwordResetUrl/get");
    }
    findFilesInfo(command) {
        return this.request(command);
    }
    getFiles(command) {
        return this.requestBlob(command);
    }
    /**住所情報検索 */
    findAddress(postCode) {
        let command = new FindAddressCommand(postCode);
        return this.request(command);
    }
    /**銀行情報検索 */
    findBank() {
        return this.api.get("common/bank/find");
    }
    /**銀行情報検索 */
    findBankBranch(command) {
        return this.request(command);
    }
}
